import axios from "axios";
import {
  IActionAddCoefficient,
  IActionEditCoefficient,
} from "../../../types/contractsInterface";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";
import {
  reducerGetCoefficientList,
  reducerSetRequestStatus,
} from "../../reducer/contracts/reducers/reducerCoefficientList";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionAddCoefficient =
  (data: IActionAddCoefficient) =>
  async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const contractId = data.contract ? parseInt(data.contract) : 0;

    try {
      const { status } = await axios.patch(
        `${BASE_URL}/json/contracts/budget`,
        {
          project: {
            id: data.project?.value,
            name: data.project?.label,
          },
          contract: {
            id: contractId,
          },
          coefficient: parseFloat(data.coefficient),
          month: data.date ? data.date.getMonth() + 1 : 0,
          year: data.date?.getFullYear(),
        }
      );
      dispatch(reducerSetRequestStatus(status));
      dispatch(actionGetCoefficientList(contractId));
    } catch (e: any) {
      if (e.response && e.response.status === 400) {
        dispatch(reducerSetRequestStatus(e.response.status));
      }
      if (e.response && e.response.status === 401) {
        window.location.href = "/login";
      }
    }
  };

export const actionEditCoefficient =
  (data: IActionEditCoefficient) => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const contractId = data.contract ? parseInt(data.contract) : 0;

    try {
      const { status } = await axios.patch(
        `${BASE_URL}/json/contracts/budget`,
        {
          contractBudget: {
            id: data.contractId,
          },
          project: {
            id: data.project?.value,
            name: data.project?.label,
          },
          contract: {
            id: contractId,
          },
          coefficient: parseFloat(data.coefficient),
          month: data.date ? data.date.getMonth() + 1 : 0,
          year: data.date?.getFullYear(),
        }
      );
      dispatch(reducerSetRequestStatus(status));
      dispatch(actionGetCoefficientList(contractId));
    } catch (e: any) {
      if (e.response && e.response.status === 401) {
        window.location.href = "/login";
      }
      if (e.response && e.response.status === 400) {
        dispatch(reducerSetRequestStatus(400));
      }
    }
  };

export const actionDeleteCoefficient =
  (data: any) => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const contractId = data.contract ? parseInt(data.contract) : 0;

    try {
      const { status } = await axios.delete(
        `${BASE_URL}/json/contracts/budget/${data.contractId}`);
      dispatch(reducerSetRequestStatus(status));
      dispatch(actionGetCoefficientList(contractId));
    } catch (e: any) {
      if (e.response && e.response.status === 401) {
        window.location.href = "/login";
      }
    }
  };

export const actionGetCoefficientList =
  (data: any) => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(`${BASE_URL}/json/contracts/budget`, {
        contract: {
          id: data,
        },
      });
      
      dispatch(reducerGetCoefficientList(response.data));
    } catch (e: any) {
      if (e.response && e.response.status === 401) {
        window.location.href = "/login";
      }
    }
  };

export const actionImportCoefficients =
    (contractId?: number, files?: File[]) => async (dispatch: AppDispatch) => {
        const {token} = await getToken();
        const headers = {
            Authorization: token,
            "Content-Type": "multipart/form-data",
        };

        const formData = new FormData();

        files && files.forEach((file: File) => {
            formData.append("excelFile", file, file.name);
        });

        try {
            const response = await axios.put(
                `${BASE_URL}/json/contracts/budget/import`,
                formData,
                {
                    headers: headers,
                }
            );
            dispatch(reducerSetRequestStatus(response.status));
            if (contractId) {
                dispatch(actionGetCoefficientList(contractId));
            }
        } catch (e: any) {
            if (e.response && e.response.status === 401) {
                window.location.href = "/login";
            }
            if (e.response && e.response.status === 400) {
                dispatch(reducerSetRequestStatus(400));
            }
            if (e.response && e.response.status === 404) {
                dispatch(reducerSetRequestStatus(404));
            }
        }
    };